import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { WidgetPositioning } from "@src/types/dashboards";

export interface PatchPositioningV2Result {
  success: boolean;
  error?: string;
}

export const patchPositioningV2UseCase = async (
  dashboardId: string,
  positioning: Record<string, WidgetPositioning>,
): Promise<PatchPositioningV2Result> => {
  try {
    const authContext = store.getState().yourSlice.authContext;
    if (!authContext) {
      return { success: false, error: "Not authenticated" };
    }
    await apiUseCases.patchPositioningV2(
      authContext.customerNamespace,
      dashboardId,
      positioning,
    );

    return { success: true };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to save widget positions")
        .message,
    };
  }
};
